import React from "react";

/* 选择型清单项：编号 · 问题 · PM 现场动作 · A–D 单选（大按钮，适合手机现场点选） */
export const SurveyItem = ({ item, value, onChange, zh, missing, idx }) => (
  <div className={`rounded-xl border bg-white p-3 sm:p-4 space-y-2 ${missing ? "border-red-300 ring-1 ring-red-200" : "border-slate-200"}`} data-testid={`survey-item-${item.code}`}>
    <div className="flex items-start gap-2">
      <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-slate-900 text-white shrink-0 mt-0.5">{item.code}</span>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 leading-snug">{zh ? item.q.zh : item.q.en}</p>
        <p className="text-xs text-slate-500 mt-1"><span className="font-semibold text-slate-600">{zh ? "PM 现场动作：" : "PM field action: "}</span>{zh ? item.action.zh : item.action.en}</p>
      </div>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5" role="radiogroup" aria-label={item.code}>
      {item.options.map((opt, i) => {
        const L = String.fromCharCode(65 + i);
        const on = value === L;
        return (
          <button key={L} type="button" role="radio" aria-checked={on} onClick={() => onChange(on ? null : L)} data-testid={`survey-opt-${item.code}-${L}`}
            className={`text-left text-xs rounded-lg border px-3 py-2.5 transition-colors ${on ? "bg-slate-900 text-white border-slate-900" : "bg-slate-50 text-slate-700 border-slate-200 hover:border-slate-400 active:bg-slate-100"}`}>
            <span className={`font-bold mr-1.5 ${on ? "text-amber-300" : "text-slate-400"}`}>{L}.</span>{opt}
          </button>
        );
      })}
    </div>
    {missing && <p className="text-[10px] text-red-600" data-testid={`survey-missing-${item.code}`}>{zh ? "请选择一项" : "Please select one"}</p>}
  </div>
);

const LEVEL_CLS = {
  low: ["border-emerald-300 bg-emerald-50", "bg-emerald-600"],
  mid: ["border-amber-300 bg-amber-50", "bg-amber-500"],
  high: ["border-red-300 bg-red-50", "bg-red-600"],
  review: ["border-violet-300 bg-violet-50", "bg-violet-600"],
};

/* 最终结论：四级风险卡片单选 */
export const SurveyConclusion = ({ page, levels, value, onChange, zh, missing }) => (
  <div className={`rounded-xl border bg-white p-3 sm:p-4 space-y-2 ${missing ? "border-red-300 ring-1 ring-red-200" : "border-slate-200"}`} data-testid="survey-conclusion">
    <p className="text-sm font-bold text-slate-900">{zh ? "最终选择结果" : "Final result"}</p>
    <p className="text-xs text-slate-500">{zh ? "PM 最后必须选择一个结论。" : "PM must choose one conclusion."}</p>
    <div className="space-y-1.5" role="radiogroup">
      {page.conclusions.map((c) => {
        const on = value === c.key;
        const [box, dot] = LEVEL_CLS[c.key];
        return (
          <button key={c.key} type="button" role="radio" aria-checked={on} onClick={() => onChange(c.key)} data-testid={`survey-conclusion-${c.key}`}
            className={`w-full text-left rounded-lg border-2 px-3 py-2.5 transition-colors ${on ? box + " border-current" : "border-slate-200 hover:border-slate-400"}`}>
            <div className="flex items-center gap-2">
              <span className={`text-[10px] font-bold text-white px-1.5 py-0.5 rounded ${dot}`}>{zh ? levels[c.key].zh : levels[c.key].en}</span>
              <span className="text-xs font-semibold text-slate-900">{zh ? c.label.zh : c.label.en}</span>
            </div>
            <p className="text-[11px] text-slate-500 mt-1">{zh ? c.desc.zh : c.desc.en}</p>
          </button>
        );
      })}
    </div>
    {missing && <p className="text-[10px] text-red-600" data-testid="survey-missing-CONCLUSION">{zh ? "请选择结论" : "Please choose a conclusion"}</p>}
  </div>
);
